import { render, staticRenderFns } from "./LangCurrencyChanger.vue?vue&type=template&id=116f0536"
import script from "./LangCurrencyChanger.vue?vue&type=script&lang=js"
export * from "./LangCurrencyChanger.vue?vue&type=script&lang=js"
import style0 from "./LangCurrencyChanger.vue?vue&type=style&index=0&id=116f0536&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports